VjsAdmin.licenseGoogleMapping = (function () {
    const me = {};
    const districtGuid = $('.district-info').data('district-guid');
    const platform = $('.platform-info').data('platform-id');

    const init = function () {
        const licenseMappingView = new AddLicenseMappingView();
        licenseMappingView.fetch('', 'post');
    };
    const successAlert = function (alertMessage) {
        const alert = `<div class="alert alert-success" role="alert">\
                            <i class="fa fa-thumbs-o-up" aria-hidden="true"></i>\
                            <span>${alertMessage}</span>\
                            <a href="#" class="close" data-dismiss="alert" aria-label="close">×</a>\
                        </div>`;

        $('.alert-div').html(alert);
    };
    const dangerAlert = function (alertMessage) {
        const alert = `<div class="alert alert-danger" role="alert">\
                            <span>${alertMessage}</span>\
                        </div>`;
        $('.alert-div').html(alert);
    };

    const AddLicenseMappingView = VjsUtility.View.extend({
        parent: '#view-body',
        templateUrl: '/assets/templates/google/mapping/license-mapping-template.html',
        dataUrl() {
            return Slim.Router.pathFor('platforms.districts.licenses.list.json', {
                platform_id: platform,
                district_joint_guid: districtGuid,
            });
        },
        after(response) {
            response.data.forEach((obj) => {
                new me.LicenseMappingComponentView().render(obj);
            });
        },
    });

    me.LicenseMappingComponentView = VjsUtility.View.extend({
        parent: '.license-view',
        templateUrl: '/assets/templates/google/mapping/license-mapping-component.html',
        licensId: '',
        events: {
            'click #add-direct-mapping': 'clickAddDirectMapping',
        },
        after(res) {
            const licenseId = res.license_id;
            this.licenseId = res.license_id;
            $('.license-mapping-component').detach().appendTo('#added-license-view');
            const req = new VjsUtility.Request();
            req.get(
                `/platforms/${platform}/districts/${districtGuid}/google/direct-mapping/?conditional_key=${res.license_id}&attribute_type=license`,
            )
                .done((orgUnitResponse) => {
                    orgUnitResponse.forEach((obj) => {
                        // TODO rename this license mapping to reference the component being used
                        const thisLicenseMapping = $(`.license-mapping-component[data-license-id="${licenseId}"]`);
                        const DirectMappingComponent = new me.DirectMappingComponentView();
                        DirectMappingComponent.parent = $(thisLicenseMapping).find('.mapping-items-view');
                        DirectMappingComponent.templateUrl = '/assets/templates/google/mapping/direct-mapping-component.html';
                        DirectMappingComponent.thisLicenseMapping = thisLicenseMapping;
                        DirectMappingComponent.render({
                            mapping_key: obj.conditional_key,
                            mapping_value: obj.conditional_value,
                            id: obj.id,
                        });
                    });
                })
                .fail((x) => {
                    dangerAlert(x.responseJSON.data);
                })
                .always(() => {});
        },
        clickAddDirectMapping(e) {
            const thisLicenseMapping = $(e.currentTarget).closest('.license-mapping-component');
            const DirectMappingComponent = new me.DirectMappingComponentView();
            DirectMappingComponent.parent = $(thisLicenseMapping).find('.mapping-items-view');
            DirectMappingComponent.templateUrl = '/assets/templates/google/mapping/new-direct-mapping-component.html';
            DirectMappingComponent.thisLicenseMapping = thisLicenseMapping;
            DirectMappingComponent.render({
                mapping_key: $(e.currentTarget).data('license-id'),
                mapping_value: '',
            });
            $('.edit-direct-mapping').attr('disabled', true);
            $('.add-direct-mapping').attr('disabled', true);
        },
    });

    me.DirectMappingComponentView = VjsUtility.View.extend({
        parent: '',
        thisLicenseMapping: '',
        directMappingText: '',
        events: {
            'click .save-direct-mapping': 'clickSaveDirectMapping',
            'click .delete-direct-mapping': 'clickDeleteDirectMapping',
            'click .edit-direct-mapping': 'clickEditDirectMapping',
            'click .cancel-direct-mapping': 'clickCancelDirectMapping',
        },
        after() {
            const addedLicenseMappings = $(this.thisLicenseMapping).find('.added-mapping-items');
            $(this.parent).find('.direct-mapping-component').detach().appendTo(addedLicenseMappings);
        },
        clickSaveDirectMapping(e) {
            // On click save the mapping to the database
            const thisMapping = e.currentTarget;
            const createMappingData = {
                mapping_value: $(thisMapping).closest('.direct-mapping-component').find('.orgunit-name').val(),
                mapping_key: $(thisMapping).closest('.direct-mapping-component').find('.orgunit-name').data('mapping-key'),
                id: $(thisMapping).data('mapping-id'),
                attribute_type: 'license',
            };
            const req = new VjsUtility.Request();
            req.put(`/platforms/${platform}/districts/${districtGuid}/google/direct-mapping/`, createMappingData)
                .done(() => {
                    const licenseMappingView = new AddLicenseMappingView();
                    licenseMappingView.fetch('', 'post');
                    successAlert('Mapping saved successfully');
                })
                .fail((x) => {
                    dangerAlert(x.responseJSON.data);
                })
                .always(() => {});
        },
        clickDeleteDirectMapping(e) {
            const mappingId = $(e.currentTarget).data('mapping-id');
            const req = new VjsUtility.Request();
            req.delete(`/platforms/${platform}/districts/${districtGuid}/google/direct-mapping/${mappingId}`)
                .done(() => {
                    const licenseMappingView = new AddLicenseMappingView();
                    licenseMappingView.fetch('', 'post');
                    successAlert('Mapping deleted successfully!');
                })
                .fail((x) => {
                    dangerAlert(x.responseJSON.data);
                })
                .always(() => {});
        },
        clickEditDirectMapping(e) {
            $(e.currentTarget).parent('.edit-button').attr('hidden', true);
            $(e.currentTarget).closest('.direct-mapping-component').find('.action-buttons').removeAttr('hidden');
            $(e.currentTarget).closest('.direct-mapping-component').find('.orgunit-name').removeAttr('disabled');
            $('.edit-direct-mapping').attr('disabled', true);
            $('.add-direct-mapping').attr('disabled', true);
        },
        clickCancelDirectMapping() {
            // This rerenders the ui, if the refresh is too jarring we can change it to be more programmatic
            const licenseMappingView = new AddLicenseMappingView();
            licenseMappingView.fetch('', 'post');
        },
    });

    return {
        init,
    };
}());
